// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.address_sDKV6 {
  position : absolute;
  top : var( --size-padLarge, 24px);
  left : var( --size-padLarge, 24px);
  width : 320px;
  max-width : 50%;
}
`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/lib/imagine/map/GeoJsonPointer.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,kCAAkC;EAClC,aAAa;EACb,eAAe;AACjB","sourcesContent":[".address {\n  position : absolute;\n  top : var( --size-padLarge, 24px);\n  left : var( --size-padLarge, 24px);\n  width : 320px;\n  max-width : 50%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"address": `address_sDKV6`
};
export default ___CSS_LOADER_EXPORT___;
